import { ConfirmFirstLoan } from './components/ConfirmFirstLoan';
import { HowDidYouFindUs } from './components/HowDidYouFindUs';

interface FirstLoanReachoutProps {
    required?: boolean;
    isReview?: boolean;
}

export const FirstLoanReachout: React.FC<FirstLoanReachoutProps> = ({ required, isReview = false }) => {
    return (
        <>
            <ConfirmFirstLoan
                required={required}
                isReview={isReview}
            />
            <HowDidYouFindUs isReview={isReview} />
        </>
    );
};
